const namespace = 'USER/';

export const CREATE_USER = namespace + 'CREATE_USER';
export const UPDATE_DETAILS = namespace + 'UPDATE_DETAILS';

